module.exports = __webpack_public_path__ + "img/woman.9a84cc2e.png";